import i18n from '@/plugins/i18n';
import Cookies from 'js-cookie';

export const setStoreInfo = () => {
    return {
        name: '',
        domain: '',
        mobile: '',
        setting: {
            name : '',
            store_industry : '',
            company_name : '',
            tax_identification : '',
            phone : '',
            email_contact : '',
            address1 : '',
            address2: '',
            county : '',
            district: '',
            state: '',
            zipcode: ''
        },
        location: {
            name: '',
            address1 : '',
            address2: '',
            city: '',
            state: '',
            postcode: '',
            county : '',
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/central/account/stores/Params.js